// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { Transform } from 'class-transformer';
import { IsArray, IsInt, IsNotEmpty, ArrayNotEmpty, IsString, ValidateNested } from 'class-validator';

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class AddBlocksForm {
  @ArrayNotEmpty()
  @IsArray()
  @ValidateNested({ each: true })
  templates: TemplateForm[];

  @IsArray()
  @ArrayNotEmpty()
  @Transform(({ obj }) => obj.files)
  files: File[];
}
